import React from "react";
import { useTranslation } from "react-i18next";
import { useRevalidator, useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function TechnicalInfo({ developerId, header }) {
    const { t } = useTranslation();
    const { apiData, apiUrl } = useAppApi(url_reverse("api:developer:technical_info", { developer_id: developerId }));
    const developerCommonInfo = useRouteLoaderData("developerCommonInfo");
    const revalidator = useRevalidator();
    const { api_post } = useRequest();

    if (!apiData) return;

    const { developer } = developerCommonInfo;

    const publishBan = (ev) => {
        api_post(ev, apiUrl, {
            params: { publish_ban: ev.target.name === "ban" },
            then: (resp) => {
                if (resp.status === "ok") {
                    revalidator.revalidate();
                }
            },
        });
    };

    const buttons = (
        <>
            <DevForm.Button variant="primary" type="submit" name="save">
                {t("Сохранить")}
            </DevForm.Button>{" "}
            {!developer.publish_ban && (
                <DevForm.Button variant="danger" name="ban" onClick={publishBan}>
                    {t("Забанить")}
                </DevForm.Button>
            )}
            {developer.publish_ban && (
                <DevForm.Button variant="info" name="unban" onClick={publishBan}>
                    {t("Разбанить")}
                </DevForm.Button>
            )}
        </>
    );

    return (
        <CommonCard header={header}>
            <RenderForm buttons={buttons} />
        </CommonCard>
    );
}
